import { render, staticRenderFns } from "./NavigationCollapsedItem.vue?vue&type=template&id=1cbf42dc&"
import script from "./NavigationCollapsedItem.vue?vue&type=script&lang=js&"
export * from "./NavigationCollapsedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports